// extracted by mini-css-extract-plugin
export default {"h_mainNavNew":"index_h_mainNavNew_Bk0ho","user":"index_user_cWkBv","box":"index_box_c9Jl-","ad":"index_ad_adH-Y"};